import { combineReducers } from 'redux';
import { Namespaces } from '../namespaces';
import { appStateReducer } from './app-state';
import { modulesReducer } from './modules';
import { localeReducer } from './locale';
import { uiReducer } from './ui';
import { userReducer } from './user';
import { taskReducer } from './task';

export const rootReducer = combineReducers({
  [Namespaces.LOCALE]: localeReducer,
  [Namespaces.MODULES]: modulesReducer,
  [Namespaces.USER]: userReducer,
  [Namespaces.UI]: uiReducer,
  [Namespaces.APP_STATE]: appStateReducer,
  [Namespaces.TASK]: taskReducer
});
